import type { Condition, ConditionValue } from '../models/types'

const TRUE = '_true'
const FALSE = '_false'
const NO_VALUE = '_no_value'

export function passesConditions(conditions: Condition[], userData: Record<string, unknown>) {
  return conditions.every((condition) => passesCondition(condition, userData))
}

export function passesCondition(
  { key, operator, values }: Condition,
  userData: { [x: string]: any }
) {
  try {
    if (!key || !operator) return true

    const seenValues: Set<ConditionValue> = new Set(
      (values || []).reduce((acc: ConditionValue[], v) => {
        acc.push(...valueMapper(v))
        return acc
      }, [])
    )

    const selectedValues = userData && userData[key]
    const valuesInCondition = Array.from(seenValues)

    let result
    switch (operator) {
      case '==':
        return Array.isArray(selectedValues)
          ? valuesInCondition.some(
              (value) =>
                selectedValues.includes(value) ||
                (value === NO_VALUE && selectedValues.some((v) => !exists(v)))
            )
          : (valuesInCondition && valuesInCondition.includes(selectedValues)) ||
              (valuesInCondition.includes(NO_VALUE) && !exists(selectedValues))
      case '!=': {
        return Array.isArray(selectedValues)
          ? !valuesInCondition.some(
              (value) =>
                (selectedValues && selectedValues.includes(value)) ||
                (value === NO_VALUE && selectedValues.every((v) => exists(v)))
            )
          : !valuesInCondition ||
              (!valuesInCondition.includes(selectedValues) &&
                (valuesInCondition.includes(NO_VALUE) ? exists(selectedValues) : true))
      }
      // case 'includes': return !valuesInCondition.includes( selectedValues)
      case 'exists':
        return Array.isArray(selectedValues)
          ? Boolean(selectedValues.filter(exists).length)
          : exists(selectedValues)
      case '!exists':
        return Array.isArray(selectedValues)
          ? selectedValues.filter(exists).length === 0
          : !exists(selectedValues)
      case 'is-true':
        return selectedValues === true
      case 'is-false':
        return selectedValues === false
      case 'is-not-true':
        return selectedValues !== true
      case 'is-not-false':
        return selectedValues !== false
      case 'is-empty':
        result =
          selectedValues === undefined ||
          selectedValues === null ||
          (Array.isArray(selectedValues) && selectedValues.length === 0) ||
          (typeof selectedValues === 'string' && selectedValues.trim() === '')
        return result
      case 'is-not-empty':
        result =
          selectedValues !== undefined &&
          selectedValues !== null &&
          ((Array.isArray(selectedValues) && selectedValues.length !== 0) ||
            (typeof selectedValues === 'string' && selectedValues.trim() !== ''))
        return result
      default:
        return true
    }
  } catch (error) {
    console.error(error)
    return false
  }
}

export function exists(value: ConditionValue) {
  return value !== undefined && value !== null
}

function valueMapper(v: ConditionValue): ConditionValue[] {
  switch (v) {
    case TRUE:
      return [true]
    case FALSE:
      return [false]
    // case EMPTY:
    // case NOT_EMPTY:

    default:
      return [v]
  }
}
